
import { Component, Vue, Prop } from 'vue-property-decorator';
import { DeviceInfo } from '@/types/device-info';
import { State } from 'vuex-class';
import { Subscription } from '@/types/subscriptions';
import { durations } from '@/constants/subscriptions';
import { convertDateToReadable, unixToReadableDate } from '@/utils/datetime';
import { getSubscriptionDuration } from '@/utils/subscriptions';
import DeviceCurrentSubscriptionMenu from '../menus/DeviceCurrentSubscriptionMenu.vue';
import { SubscriptionStatus } from '@/constants/subscription_status';

@Component({
    components: { DeviceCurrentSubscriptionMenu },
})
export default class DeviceCurrentSubscription extends Vue {
    @State('device')
    device!: DeviceInfo;

    @Prop({ required: true })
    handlePause!: (subscription: Subscription, resumeDate: string) => void;

    @Prop({ required: true })
    handleResume!: (subscription: Subscription) => void;

    @Prop({ required: true })
    handleCancel!: (subscription: Subscription) => void;

    @Prop({ required: true })
    subscribedPlans!: Subscription[];

    @Prop({ required: true, default: false })
    tableLoading!: boolean;

    protected durations = durations;
    protected SubscriptionStatus = SubscriptionStatus;
    protected convertDateToReadable = convertDateToReadable;
    protected unixToReadableDate = unixToReadableDate;

    subscriptionDuration(duration: string, frequencyDays: string) {
        if (duration === 'days') return `${parseInt(frequencyDays ?? 0)} day(s)`;
        return getSubscriptionDuration(duration);
    }

    periodLabel(item: Subscription) {
        const { pause_collection } = item.sourceData;
        return pause_collection && Object.keys(pause_collection).length > 0
            ? `(Collection paused until ${unixToReadableDate(pause_collection.resumes_at, 'DD MMMM YYYY')})`
            : '';
    }
}
